<span class="icon-cont" *ngIf="icono || iconoClase">
  <i *ngIf="iconoClase; else matIcon" class="{{iconoClase}}" [ngStyle]="{'color': color}"></i>
  <ng-template #matIcon>
    <mat-icon *ngIf="icono" class="mat-icono" [ngStyle]="{'color': color}">{{icono}}</mat-icon>
  </ng-template>
</span>
